import { subscribeIntegrationApi } from '../../../api/api';
import { getErrorDetails } from '../../../api/utils/parseErrors';
import { GIS_PENDING_PAYMENT_KEY, GIS_ZHKH_KEY } from './constants';

export function buildGisSubscribePayload(config = {}) {
  const payload = {
    account_number: String(config.account_number ?? '').trim(),
    send_at_day: Number(config.send_at_day),
  };

  if (config.meter_guid) {
    payload.meter_guid = config.meter_guid;
  }

  return payload;
}

export function markGisPaymentPending(deviceId) {
  try {
    sessionStorage.setItem(GIS_PENDING_PAYMENT_KEY, String(deviceId));
  } catch {
    // ignore storage errors
  }
}

export function clearGisPaymentPending() {
  try {
    sessionStorage.removeItem(GIS_PENDING_PAYMENT_KEY);
  } catch {
    // ignore storage errors
  }
}

export function getGisPaymentPendingDeviceId() {
  try {
    return sessionStorage.getItem(GIS_PENDING_PAYMENT_KEY);
  } catch {
    return null;
  }
}

function extractSubscribeError(err) {
  let message = 'Не удалось оформить подписку';
  getErrorDetails(err, (errorObj) => {
    if (errorObj?.error) message = errorObj.error;
  });
  return message;
}

/** Creates a YooKassa payment for gis_zhkkh and redirects to confirmation_url. */
export async function subscribeGisZhkkh({ deviceId, config, redirect = true }) {
  const payload = buildGisSubscribePayload(config);

  let payment;
  try {
    payment = await subscribeIntegrationApi(payload, GIS_ZHKH_KEY, deviceId);
  } catch (err) {
    throw new Error(extractSubscribeError(err));
  }

  if (!payment?.confirmation_url) {
    throw new Error('Не получена ссылка на оплату');
  }

  markGisPaymentPending(deviceId);

  if (redirect) {
    window.location.assign(payment.confirmation_url);
  }

  return payment;
}
